export const TEST_ID = 'aircraftCard';
